export default "__VITE_ASSET__BNz$U3og__"